/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentGoCampaign_PoliticalDistrictGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Political District Group API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, July 06, 2019 - 06:10:28 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      07/06/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const GoCampaign_PoliticalDistrictGroups = {
    all: (countryid, stateid, countyid, cityid, zipcode) => requests.get(`/PoliticalDistrictGroups?countryid=${countryid}&stateid=${stateid}&countyid=${countyid}&cityid=${cityid}&zipcode=${zipcode}`),
    get: politicaldistrictgroupid => requests.get(`/PoliticalDistrictGroup/${politicaldistrictgroupid}`),
    create: politicaldistrictgroup => requests.post(`/PoliticalDistrictGroups`, politicaldistrictgroup),
    update: (politicaldistrictgroupid, politicaldistrictgroup) => requests.put(`/PoliticalDistrictGroup/${politicaldistrictgroupid}`, politicaldistrictgroup),
    delete: politicaldistrictgroupid => requests.del(`/PoliticalDistrictGroup/${politicaldistrictgroupid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentGoCampaign_PoliticalDistrictGroups.js